import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ct-menu',
  templateUrl: './ct-menu.component.html',
  styleUrls: ['./ct-menu.component.css']
})
export class CtMenuComponent implements OnInit {

  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Correspondance Track')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/correspondance-tracking/ct-menu/ct-menu.component.ts